import Disclosure from './disclosure'
import withDisclosure from './graphql/withDisclosure'

export {Disclosure, withDisclosure}
